import React from 'react';
import SEO from '@/SEO';

const HTML_CONTENT = `<h1>உபநயனம்</h1>`;

const UpanayanamPage = () => {
  return (
    <div className="vaideekam-page-container w-full max-w-4xl mx-auto p-4 md:p-6 pb-24">
      <SEO title="உபநயனம் - Ahobilam" />
      <div 
        className="vaideekam-content bg-white p-6 rounded-xl shadow-sm border border-green-100/50"
        dangerouslySetInnerHTML={{ __html: HTML_CONTENT }} 
      />
    </div>
  );
};

export default UpanayanamPage;
